import styled from "styled-components";

import { Variables } from "../../Variables";

export const ContainerGlobal = styled.div`
  position: relative;
  width: 99.3vw;
  height: 100hv;
  align-self: center;

  @media (max-height: 650px) {
    height: auto;
  }
`;

export const HeadContainer = styled.div`
  padding: 10px 0;
  margin-top: 2%;
  display: flex;
  margin-left: 10%;
  width: 80%;
  justify-content: space-evenly;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: ${Variables.colorBlue};
  color: ${Variables.colorWhite};

  @media (max-height: 650px) {
    height: auto;
  }
`;

export const ContainerInfo = styled.div`
  padding: 10px 0;
  display: flex;
  width: 79.89%;
  margin-left: 10%;
  align-items: center;
  justify-content: space-evenly;
  border-bottom: 1px solid ${Variables.colorGrayLine};

  @media (max-height: 650px) {
    height: auto;
  }
`;

export const DivInfo = styled.div`
  text-align: center;
  overflow-wrap: break-word;
  width: 33%;
`;
export const BackButton = styled.a`
  color: ${Variables.colorBlackDark};
`;

export const ContainerBack = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2%;
  margin-left: 10%;
  justify-content: center;
  margin-bottom: 15px;
  padding: 5px 0;
  background-color: ${Variables.colorGrayBack};
  width: 8%;

  @media (max-width: 820px) {
    width: 20%;
  }
`;

export const TextBack = styled.h3`
  margin-left: 10px;
  font-weight: 500;
`;
